import { AppTicketScan, ScanTicketBulk, TicketScanType } from "@graphql/sdk";
import { DeviceTicket } from "@state/types";

export function getTicketScans(
  ticket: DeviceTicket,
  pendingScans: ScanTicketBulk[],
  eventId: string
): AppTicketScan[] {
  const scanKey = (scan: AppTicketScan) =>
    `${new Date(scan.scannedAt).getTime()}:${scan.direction?.toUpperCase().replace("-", "_")}`;
  const scans = new Map(ticket.scans.map((scan) => [scanKey(scan), scan]));

  for (const pending of pendingScans) {
    if (
      (pending.eventId != null && pending.eventId !== eventId) ||
      (pending.ticketNumber !== ticket.ticketNumber &&
        pending.ticketNumber !== ticket.parentTicketNumber)
    ) {
      continue;
    }

    const scan: AppTicketScan = {
      id: `pending:${pending.scannedAt}`,
      scannedAt: pending.scannedAt,
      direction: pending.scanDirection,
      type: pending.scanType ?? TicketScanType.Digital,
    };
    // Sync updates the ticket snapshot before removing its pending scans.
    if (!scans.has(scanKey(scan))) {
      scans.set(scanKey(scan), scan);
    }
  }

  return [...scans.values()].sort(
    (a, b) => new Date(a.scannedAt).getTime() - new Date(b.scannedAt).getTime()
  );
}
